module.exports = __webpack_public_path__ + "static/media/injury.0406a285.svg";